import { Link } from '@tanstack/react-router'

import { cn } from '@/lib/cn'

export function BrandLogo({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      aria-label="LioJastip — Halaman utama aplikasi"
      className={cn(
        'border-line inline-flex h-11 w-[170px] shrink-0 items-center justify-center rounded-full border bg-white px-3.5',
        className,
      )}
    >
      <img src="/assets/logo-liojastip.svg" alt="LioJastip" width={140} height={30} />
    </Link>
  )
}
